<template>
  <modal name="member-type-update-modal" class="member-type-update-modal"
         :width="300"
         :height="'auto'"
         @before-open="handlerBeforeOpen"
         @before-close="handlerBeforeClose"
  >
    <div class="modal_title">회원 유형</div>
    <button class="close_btn" style="z-index: 99" @click="closeModal"></button>
    <div class="text_center mt30 mb50">
      <el-select class="select curator_select" v-model="memberTypeUpdate"
                 @change="changeType(memberTypeUpdate)">
        <el-option :value="0" :label="'일반'"></el-option>
        <el-option :value="1" :label="'스페셜'"></el-option>
        <!-- <el-option :value="7" :label="'디렉터'"></el-option>
        <el-option :value="8" :label="'매니저'"></el-option> -->
      </el-select>
    </div>
    <div class="pl30 pr30 pb30">
      <div class="btn_box text-center mt20">
        <el-button class="reg_btn_out" @click="save">학인</el-button>
      </div>
    </div>
  </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";

export default {
  name: "MemberTypeUpdateModal",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      memberTypeUpdate: 0,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    handlerBeforeOpen(event) {
      this.memberTypeUpdate = event.params;
    },
    handlerBeforeClose() {
      this.$router.replace(this.$route.path);
    },
    closeModal() {
      this.$modal.hide('member-type-update-modal')
    },
    changeType(value){
      this.memberTypeUpdate = value;
    },
    save(){
      EventBus.$emit('updateMemberType', this.memberTypeUpdate, 'memberType');
      this.$modal.hide('member-type-update-modal')
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
